import { Injectable } from '@angular/core';
import {FormArray, FormControl, FormGroup, Validators} from '@angular/forms';
import { QuestionBase } from '../question-based-answers/question-base/question-base';

declare const  _: any;
declare const moment: any;
@Injectable({
    providedIn: 'root'
})

export class QuestionControlService {
    constructor() { }

    toFormGroup(questions: QuestionBase<string>[], lock: boolean): any {
        const group: any = {};

        questions.forEach(question => {
            if (question.type === 'Check Boxes') {
                group[question.key] =  new FormArray([]);
                question.checkBoxes.forEach((ques) => group[question.key].push(new FormControl({value: ques.checked, disabled: lock})));
            } else if (question.type === 'Rating') {
                group[question.key] = question.mandatory ? new FormControl(question.ratingAnswer || 0, Validators.min(1))
                    : new FormControl(question.ratingAnswer || 0);
            } else if (question.type === 'Multiple Choice') {
                group[question.key] = question.mandatory ? new FormControl({value: question.multipleOptionsAnswer || '', disabled: lock}, Validators.required)
                    : new FormControl({value: question.multipleOptionsAnswer || '', disabled: lock});
            } else if (question.type === 'Date') {
                group[question.key] = question.mandatory ? new FormControl({value: moment(question.dateAnswer, 'MM/DD/YYYY') || '', disabled: lock}, Validators.required)
                    : new FormControl({value: question.dateAnswer ? moment(question.dateAnswer, 'MM/DD/YYYY') : '' || '', disabled: lock});
            } else {
                group[question.key] = question.mandatory ? new FormControl({value: question.answer || '', disabled: lock}, Validators.required)
                    : new FormControl({value: question.answer || '', disabled: lock});
            }
        });
        return new FormGroup(group);
    }
}
